export default __webpack_public_path__ + "static/media/vintage65g-4.27b4c411.jpg";